import BranchDto from '@/models/Branches/BranchDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import SpecOutStatus from '@/models/SpecOuts/SpecOutStatus';

export default class CurrentSpecOutSearchCriteria {
    selectedBranch: BranchDto = null;
    selectedOwner: AgencyUserDto = null;
    selectedStatus: SpecOutStatus = SpecOutStatus.Draft;
}
